

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Radio, Divider, Space } from 'antd';
import { store } from '../../redux/store';
import { actions } from '../../redux/action';
class SingleChoiceQuestion extends Component {
    constructor(props) {
        super(props);
        this.updateAnswer = this.updateAnswer.bind(this);
    }

    updateAnswer(e) {
        const { questionId, answers } = this.props,
            answerValue = answers.find(x => x.Id === e.target.value).Value;
        store.dispatch(actions.updateAnswer(questionId, e.target.value, answerValue));
    }

    render() {
        const { questionText, answers, questionNumber, required } = this.props;
        let direction = answers.length > 2 ? "horizontal" : "vertical";
        if (direction === "horizontal" && window.innerWidth < 400)
            direction = "vertical";

        return (
            <div className="Question-Holder">
                <div><h3>{required === true ? <span style={{ color: 'red' }}>*</span> : ""}{"Question #" + questionNumber + ": " + questionText}</h3></div>
                <div className="Radio-Holder">
                    <Radio.Group onChange={e => this.updateAnswer(e)}>
                        <Space direction={direction}>
                            {answers.map((x, i) => {
                                return (<Radio key={`answer-${i}`} value={x.Id}>{x.Text}</Radio>)
                            })}
                        </Space>
                    </Radio.Group>
                </div>
                <Divider />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        surveyResponse: state.surveyResponse,
    };
};
export default connect(mapStateToProps)(SingleChoiceQuestion);